import QuotaSettingsDialogContent from './QuotaSettingsDialogContent';

export default QuotaSettingsDialogContent;
